import { ChevronLeft } from '../../../modules/design-system';
import { SleekButton } from '../../../modules/theme';

type Props = {
  onBack: () => void;
  /** Centred page title; the card page has none. */
  title?: string;
  /** Page colour behind the bar, for pages whose content scrolls under it.
   *  Off on the card page: nothing scrolls there and the fill would cut its
   *  rarity glow. */
  isOpaque?: boolean;
};

/** Sleek sub-page top bar (partner Figma 2026-10-08): the round back arrow and
 *  a centred title, laid out like the Vault's header (MyPacksHeader) so the
 *  arrow sits where the Vault's Home button was. The partner Figma is
 *  phone-only; on a wide screen a 480px column left the arrow jumping
 *  ~460px between the Vault and its sub-pages. From 600px the row is as tall
 *  as the Vault's 44px Home pill, so the arrow's centre lines up with it. */
export function SleekPageHeader({ onBack, title, isOpaque = true }: Props) {
  return (
    <header className={`sticky top-0 z-30 header-safe-top ${isOpaque ? 'bg-[var(--co-MyPacksPageBackground-gradientFrom,#0E0F11)]' : ''}`}>
      <div className="mx-auto grid w-full max-w-350 grid-cols-[40px_minmax(0,1fr)_40px] items-center px-5 py-4 @[600px]:auto-rows-[minmax(44px,auto)] @[600px]:px-6 @[600px]:py-5">
        <SleekButton name="SleekBackButton" aria-label="Back" onClick={onBack}>
          <ChevronLeft size={16} />
        </SleekButton>
        {title && (
          <h1 className="m-0 truncate text-center text-[18px] leading-[24px] font-medium tracking-[-0.44px] text-[var(--co-Tabs-tabIdleText,#FFFFFF)]">
            {title}
          </h1>
        )}
      </div>
    </header>
  );
}
